import React from 'react';
import {Box, Grid} from "@mui/material";
import Link from "@mui/material/Link";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {numOnKeyDown} from "../../../../../tools/helper";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router";

const RegisterNewStep3 = ({setSlideIndex}) => {
    const navigate = useNavigate();
    return (
        <Grid container sx={{alignItems: 'center', justifyContent: 'center'}}>

            <Box sx={{
                my: 8,
                mx: 4,
                flexDirection: 'column',
                width: {xs:'null',md:'60%'}

            }}>
                <Grid sx={{justifyContent: 'flex-end'}}>
                    <Link onClick={() => setSlideIndex(1)}
                          underline="none" href="#"
                          variant="body2">
                        <KeyboardBackspaceIcon/>
                    </Link>
                </Grid>


                <Grid sx={{textAlign: 'center', mb: 2, fontSize:{xs:'12px',sm:'12px'}}}>
                    <Typography>
                        اطلاعات خود را وارد کنید
                    </Typography>
                </Grid>
                <Box  noValidate >
                    <TextField
                        
                        required
                        fullWidth
                        name="password"
                        label="نام و نام خانوادگی"
                        id="password"
                        autoComplete="current-password"
                        autoFocus
                    />

                    <TextField sx={{marginBottom:'15px',marginTop:'15px'}} onKeyDown={numOnKeyDown}
                               required
                               fullWidth
                               type="number"
                               label="کد ملی"

                    />

                    <TextField
                        
                        required
                        fullWidth
                        name="password"
                        label="ایمیل (اختیاری)"
                        id="password"
                        autoComplete="current-password"
                    />

                    <Button
                        onClick={() => navigate('/admin/login')}
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            my: 2,
                            padding: '12px',
                            borderRadius: '40px',
                            backgroundColor: '#592EA9',
                             ":hover": {bgcolor: '#5D5FEF'}
                        }}
                    >
                    وارد شو
                </Button>


            </Box>
        </Box>
</Grid>
)
    ;
};

export default RegisterNewStep3;